export const NOTIFICATIONS_URL = '/notification/v2/notifications';
